export type DeckId = 'classic' | 'alternative';
export type TableTheme = 'green' | 'blue' | 'red';

export type DeckSettings = {
  selectedDeck: DeckId;
  tableTheme: TableTheme;
};

const DECK_SETTINGS_KEY = 'poker_deck_settings_v1';
const DEFAULT_SETTINGS: DeckSettings = {
  selectedDeck: 'classic',
  tableTheme: 'green',
};

const normalizeDeckId = (value: unknown): DeckId => {
  // Migration: old 'classic' was PSYCHOPATÓW (now 'alternative'), old 'neon' was KLASYCZNA (now 'classic')
  if (value === 'neon') return 'classic';
  if (value === 'alternative') return 'alternative';
  return 'classic';
};

const normalizeTableTheme = (value: unknown): TableTheme => {
  if (value === 'blue') return 'blue';
  if (value === 'red') return 'red';
  if (value === 'cyber') return 'red';
  if (value === 'classic') return 'green';
  return 'green';
};

export const loadDeckSettings = (): DeckSettings => {
  try {
    const stored = localStorage.getItem(DECK_SETTINGS_KEY);
    if (!stored) return { ...DEFAULT_SETTINGS };
    const parsed = JSON.parse(stored) as Partial<DeckSettings>;
    return {
      selectedDeck: normalizeDeckId(parsed.selectedDeck),
      tableTheme: normalizeTableTheme(parsed.tableTheme),
    };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
};

export const saveDeckSettings = (settings: DeckSettings): void => {
  const normalized: DeckSettings = {
    selectedDeck: normalizeDeckId(settings.selectedDeck),
    tableTheme: normalizeTableTheme(settings.tableTheme),
  };
  try {
    localStorage.setItem(DECK_SETTINGS_KEY, JSON.stringify(normalized));
  } catch {
    // Persisting settings is best-effort; ignore storage errors
  }
};
